































import { ProcessamentoFilaMensagensService } from "@/services/processamentoFilaMensagem.service";
import { ToastService } from "@/services/toast.service";
import Modal from "@/shared/components/modal.vue";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";

@Component({
  components: { Modal },
})
export default class JsonView extends Vue {
  titulo: string | null = null;
  json: string | null = null;
  loading = true;

  show = false;
  showErro = false;

  @Watch("$route.params", { deep: true })
  onParamsChange() {
    const params = this.$route.params;
    const idProcessamentoFilaMensagem = params.idProcessamentoFilaMensagem;
    const idItemProcessamentoFilaMensagem =
      params.idItemProcessamentoFilaMensagem;
    const campo = params.campo || "original";

    this.loading = true;
    ProcessamentoFilaMensagensService.obterItem(
      idProcessamentoFilaMensagem,
      idItemProcessamentoFilaMensagem
    )
      .then((item) => {
        switch (campo) {
          case "original":
          default:
            this.json = item.jsonOriginal;
            break;
          case "alterado":
            this.json = item.jsonAlterado || item.jsonOriginal;
            break;
        }
      })
      .finally(() => (this.loading = false));
  }

  mounted() {
    this.onParamsChange();
  }

  copiarMensagem() {
    const mensagemCopiada = document.getElementById(
      "mensagem"
    ) as HTMLInputElement;
    if (this.json) {
      mensagemCopiada.select();
      document.execCommand("copy");
    }

    this.show = true;
    setTimeout(this.fechaAlerta, 5000);
  }

  fechaAlerta() {
    this.show = false;
    this.showErro = false;
  }

  voltar() {
    this.$router.go(-1);
  }

  validaJson(json: string) {
    try {
      JSON.parse(json);
      return true;
    } catch {
      return false;
    }
  }

  alterarJson() {
    if (this.json && this.validaJson(this.json)) {
      const params = this.$route.params;
      const idProcessamentoFilaMensagem = params.idProcessamentoFilaMensagem;
      const idItemProcessamentoFilaMensagem =
        params.idItemProcessamentoFilaMensagem;

      this.loading = true;
      ProcessamentoFilaMensagensService.alterarJson(
        idProcessamentoFilaMensagem,
        idItemProcessamentoFilaMensagem,
        this.json
      )
        .then(() => {
          ToastService.open({
            message: "Json Alterado com sucesso",
            type: "success",
            duration: 3000,
            position: "bottom-end",
          });
        })
        .then(() => {
          this.$router.go(-1);
        })
        .finally(() => (this.loading = false));
    } else {
      this.showErro = true;
    }
  }
}
